import React from 'react'
import './value-key-label.css'

export default function ValueKeyLabel({title, children}) {
    return (<div className='value-key-label'>
        <p>{title}:</p>
        {children}
    </div>)
}
